import React, { useState, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../Login/AuthContext';
import api from '../../api';
import './AppNavbar.css';

const AppNavbar = () => {
  const location = useLocation();
  const { user, logout } = useContext(AuthContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  // Determine active tab based on current path
  const currentPath = location.pathname;
  const isActive = (path) => {
    if (path === '/app/create' && (currentPath === '/app/create' || currentPath === '/app')) return true;
    if (path === '/app/upload' && currentPath === '/app/upload') return true;
    if (path === '/app/gallery' && currentPath === '/app/gallery') return true;
    return false;
  };

  // Calculate total tokens from user data
  const getUserTotalTokens = () => {
    if (!user) return 0;
    return (user.tokens_ltd || 0) + (user.tokens_subscription || 0);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    closeMobileMenu();
    logout();
    // Navigate to home/landing page
    window.location.href = '/';
  };
  
  // Handle click on Subscription button
  const handleSubscription = async () => {
    if (isLoading) return; // Avoid multiple clicks
    
    closeMobileMenu();
    setIsLoading(true);
    try {
      const response = await api.get('/stripe_dashboard');
      if (response.data && response.data.dashboard_url) {
        window.location.href = response.data.dashboard_url;
      }
    } catch (error) {
      console.error('Error retrieving Stripe dashboard:', error);
      setIsLoading(false);
    }
  };

  return (
    <nav className="app-navbar">
      <div className="app-navbar-container">
        <div className="app-navbar-brand">
          <Link to="/" className="app-navbar-logo" onClick={closeMobileMenu}>
            AIvatar
          </Link>
          <button 
            className={`app-navbar-toggle ${mobileMenuOpen ? 'active' : ''}`} 
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <div className={`app-navbar-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <div className="app-navbar-nav">
            <Link 
              to="/app/create" 
              className={`app-navbar-link ${isActive('/app/create') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Create Avatar
            </Link>
            <Link 
              to="/app/upload" 
              className={`app-navbar-link ${isActive('/app/upload') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              Manage Photos
            </Link>
            <Link 
              to="/app/gallery" 
              className={`app-navbar-link ${isActive('/app/gallery') ? 'active' : ''}`}
              onClick={closeMobileMenu}
            >
              My Avatars
            </Link>
          </div>
          
          <div className="app-navbar-user">
            <div className="app-navbar-user-info">
              {user && (
                <>
                  <div className="app-navbar-email">
                    {user.email || 'User'}
                  </div>
                  <div className="app-navbar-tokens">
                    <span className="token-icon">🪙</span>
                    <span className="token-count">{getUserTotalTokens()}</span>
                  </div>
                </>
              )}
            </div>
            <div className="app-navbar-actions">
              {user && user.stripe_customer_id && (
                <button 
                  className={`app-navbar-subscription-btn ${isLoading ? 'loading' : ''}`}
                  onClick={handleSubscription}
                  disabled={isLoading}
                >
                  {isLoading ? 'Loading...' : 'Subscription'}
                </button>
              )}
              <button className="app-navbar-logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AppNavbar; 